import reducer from "./reducer";
export { default as Home } from "./components/index";
export { default as homeReducerName } from "./constants";
export default reducer;
